import React, { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { type LoginRequestData } from '../types/auth'
import { useLoginUserMutation } from '../store/api/authApi'

export function LoginPage (): JSX.Element {
  const navigate = useNavigate()
  const [loginUser] = useLoginUserMutation()

  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [showError, setShowError] = useState<boolean>(false)

  const onLoginClicked = useCallback(async () => {
    try {
      const request: LoginRequestData = {
        email,
        password
      }

      const loginRes = await loginUser({ data: request }).unwrap()
      navigate('/home')
      setShowError(false)

      console.dir(loginRes)
    } catch (e) {
      setShowError(true)
    }
  }, [email, password, loginUser])

  const isEmailValid = useCallback(() => {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)
  }, [email])

  return (
    <div className="page-auth page-login container-fluid">
      <div className="content-row row">
        <h3 className="mb-5 text-center">Grant Classifier</h3>
        <div className="form-group mb-3">
          <label htmlFor="email" className="mb-1">Email</label>
          <input id="email" name="email" value={email} onChange={(e) => { setEmail(e.target.value) }}/>
        </div>
        <div className="form-group mb-5">
          <label htmlFor="password" className="mb-1">Password</label>
          <input id="password" name="password" type="password" value={password} onChange={(e) => { setPassword(e.target.value) }}/>
        </div>
        <button className="btn-confirm mb-3" onClick={onLoginClicked} disabled={!isEmailValid() || !password}>Log in</button>
        {
          showError ? <div className="error text-center mb-5">Failed to login</div> : null
        }
      </div>
    </div>
  )
}
